<template>
  <section v-if="$vuetify.breakpoint.smAndUp">
    <v-flex v-if="documentTabs.length > 0" grow class="grid-container">
      <div class="grid-image">
        <component :is="$vuetify.breakpoint.mdAndUp ? 'h2' : 'h3'">{{
          $t(title)
        }}</component>

        <v-tabs
          v-model="active"
          light
          slider-color="brand"
          color="brand"
          show-arrows
        >
          <v-tab
            v-for="tab in documentTabs"
            :key="tab"
            ripple
            class="cursor-pointer"
          >
            <div>{{ tab }}</div>
          </v-tab>
        </v-tabs>
      </div>
      <template
        v-for="(field, i) in onlyPopulatedFields(onlyPopulatedSections)"
      >
        <div
          v-if="
            field.type.toLowerCase() !== 'file' &&
              field.type.toLowerCase() !== 'linksto'
          "
          class="supply-chain-content"
          :key="i + ' -tab'"
        >
          <h3>
            {{
              findTranslationMultipleOptions(
                field.name,
                documentDefaultLang,
                defaultLanguage
              )
            }}
          </h3>
          <p
            v-if="
              !['map', 'date', 'url', 'multi-select'].includes(
                field.type.toLowerCase()
              )
            "
            class="primary--text mt-1 text-and-area"
            v-html="
              findTranslationMultipleOptions(
                field.value,
                documentDefaultLang,
                defaultLanguage
              )
            "
          ></p>

          <!-- Multi Select -->
          <div v-else-if="field.type.toLowerCase() === 'multi-select'">
            <div class="mb-2">
              <span>{{
                findTranslationMultipleOptions(
                  field.value,
                  documentDefaultLang,
                  defaultLanguage
                ).text
              }}</span>
            </div>

            <v-checkbox
              v-for="item in findTranslationMultipleOptions(
                field.value,
                documentDefaultLang,
                defaultLanguage
              ).items"
              :key="item.label"
              v-model="item.value"
              class="multi-select-check"
              dense
              hide-details
              value
              :label="item.label"
              disabled
            ></v-checkbox>
          </div>

          <base-U-R-L-Field
            v-else-if="field.type.toLowerCase() === 'url'"
            :value="
              findTranslationMultipleOptions(
                field.value,
                documentDefaultLang,
                defaultLanguage
              )
            "
            :editMode="false"
          ></base-U-R-L-Field>

          <p
            v-else-if="field.type.toLowerCase() === 'date'"
            class="primary--text mt-1"
          >
            {{
              momentDate(
                findTranslationMultipleOptions(
                  field.value,
                  documentDefaultLang,
                  defaultLanguage
                )
              )
            }}
          </p>

          <new-base-map
            v-else
            :location="
              findTranslationMultipleOptions(
                field.value,
                documentDefaultLang,
                defaultLanguage
              )
            "
            :height="'350px'"
            :zoom="14"
            class="mt-1 mb-4"
          ></new-base-map>
        </div>

        <div
          v-else-if="field.type.toLowerCase() === 'linksto'"
          :key="
            `${documentKey}
            ${findTranslationMultipleOptions(
              field.name,
              documentDefaultLang,
              defaultLanguage
            )}`
          "
          class="pa-0 supply-chain-content"
        >
          <h3
            v-if="
              findTranslationMultipleOptions(
                field.value,
                documentDefaultLang,
                defaultLanguage
              ).filter(i => i.available).length > 0
            "
          >
            {{
              findTranslationMultipleOptions(
                field.name,
                documentDefaultLang,
                defaultLanguage
              )
            }}
          </h3>

          <v-list
            v-if="
              findTranslationMultipleOptions(
                field.value,
                documentDefaultLang,
                defaultLanguage
              ).filter(i => i.available).length > 0
            "
          >
            <template
              v-for="(item, itemIndex) in findTranslationMultipleOptions(
                field.value,
                documentDefaultLang,
                defaultLanguage
              )"
            >
              <v-list-item
                v-if="item.available"
                :key="`${item.id}-i-${itemIndex}`"
                class="pa-0 cursor-pointer"
                :class="[item.type !== 'CUSTOM' ? 'cursor-pointer' : '']"
                @click="redirectToLink(item)"
              >
                <v-avatar
                  :width="item.type !== 'PROFILE' ? '80px' : '30px'"
                  height="30px"
                  left
                  tile
                  class="mr-1"
                >
                  <base-image
                    type="u"
                    image-type="t"
                    :file-name="item.logo"
                    :profile-id="getProfileId(item)"
                    :contain="false"
                    :imageAlt="
                      `${$t('linked')} ${item.type.toLowerCase()} ${$t(
                        'inShowcase'
                      )} ${document.name}`
                    "
                  ></base-image>
                </v-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    ><h6 class="primary--text">
                      {{ item.name }}
                    </h6></v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <v-chip color="brand" outlined label x-small>{{
                      item.type === 'DOCUMENT'
                        ? $t('showcase')
                        : sentenceCase(setI18nSyntax(item.type))
                    }}</v-chip></v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </div>

        <v-layout
          v-else
          column
          justify-center
          align-center
          class="grid-image"
          :key="
            `${documentKey} ${findTranslationMultipleOptions(
              field.name,
              documentDefaultLang,
              defaultLanguage
            )}-${i}`
          "
        >
          <div
            v-if="field.type.toLowerCase() !== 'file'"
            class="supply-chain-content"
            :key="
              `${documentKey}
              ${findTranslationMultipleOptions(
                field.name,
                documentDefaultLang,
                defaultLanguage
              )}`
            "
          >
            <h3>
              {{
                findTranslationMultipleOptions(
                  field.name,
                  documentDefaultLang,
                  defaultLanguage
                )
              }}
            </h3>
            <p
              class="primary--text mt-1"
              v-html="
                findTranslationMultipleOptions(
                  field.value,
                  documentDefaultLang,
                  defaultLanguage
                )
              "
            ></p>
          </div>

          <base-multiple-images
            v-if="
              field.accepts &&
                field.accepts[0].toLowerCase() === 'image' &&
                field.value.names &&
                field.value.names.length > 0 &&
                field.value.names[0] !== ''
            "
            type="u"
            image-type="o"
            :profile-id="profileInfo.profile.profileId.replace('#', '')"
            :editMode="false"
            :file-names="field.value.names"
            :aspectRatio="1.618"
            :file-text="
              field.text
                ? findTranslationMultipleOptions(
                    field.text,
                    documentDefaultLang,
                    defaultLanguage
                  )
                : ''
            "
            style="border-radius: 3px; width: 100%"
            width="100%"
            :key="documentKey"
            :imageAlt="
              `${$t('imagesForShowcase')} ${
                document.name
              } ${findTranslationMultipleOptions(
                field.name,
                documentDefaultLang,
                defaultLanguage
              )}`
            "
          ></base-multiple-images>

          <base-video-player
            v-else-if="
              field.accepts &&
                field.accepts[0].toLowerCase() === 'video' &&
                field.value.names &&
                field.value.names.length > 0 &&
                field.value.names[0] !== ''
            "
            type="u"
            video-type="o"
            :profile-id="profileInfo.profile.profileId.replace('#', '')"
            :file-name="field.value.names[0]"
            width="100%"
            :key="documentKey"
            :videoKey="`video-key-${documentKey}`"
            class="mb-4"
          ></base-video-player>

          <base-sound-player
            v-else-if="
              field.accepts &&
                field.accepts[0].toLowerCase() === 'audio' &&
                field.value.names &&
                field.value.names.length > 0 &&
                field.value.names[0] !== ''
            "
            type="u"
            sound-type="o"
            :profile-id="profileInfo.profile.profileId.replace('#', '')"
            :file-name="field.value.names[0]"
            :artist="profileInfo.profile.name"
            width="100%"
            :key="documentKey"
          ></base-sound-player>

          <base-download
            v-else-if="
              field.accepts &&
                field.accepts[0].toLowerCase() === 'pdf' &&
                field.value.names &&
                field.value.names.length > 0 &&
                field.value.names[0] !== ''
            "
            type="u"
            download-type="o"
            :profile-id="profileInfo.profile.profileId.replace('#', '')"
            :file-name="field.value.names[0]"
            :show="true"
            width="100%"
            :key="documentKey"
          ></base-download>

          <base-video-link
            v-if="
              field.accepts &&
                field.accepts[0].toLowerCase() === 'video_link' &&
                field.value.names &&
                field.value.names.length > 0 &&
                field.value.names[0] !== ''
            "
            height="315px"
            :value="field.value.names[0]"
            :key="documentKey"
          ></base-video-link>
        </v-layout>
      </template>
    </v-flex>
  </section>

  <!-- For mobile version -->
  <section v-else>
    <template v-if="documentTabs.length > 0">
      <h4>{{ $t(title) }}</h4>

      <div v-for="(tab, index) in documentTabs" :key="tab">
        <div
          @click="hanldeActiveSection(index)"
          class="d-flex justify-space-between"
          :class="[active === index ? 'xs-tab-active' : 'xs-tab']"
        >
          <span
            :class="[active === index ? 'brand--text' : 'primary--text']"
            style="font-weight: 500"
            >{{ tab }}</span
          >
          <v-icon :color="active === index ? 'brand' : 'primary'">{{
            active === index ? icons.mdiChevronUp : icons.mdiChevronDown
          }}</v-icon>
        </div>

        <v-expand-transition>
          <div v-if="active === index" class="my-4">
            <template
              v-for="(field, i) in onlyPopulatedFields(onlyPopulatedSections)"
            >
              <div
                v-if="
                  field.type.toLowerCase() !== 'file' &&
                    field.type.toLowerCase() !== 'linksto'
                "
                class="supply-chain-content"
                :key="i + ' -tab'"
              >
                <h3>
                  {{
                    findTranslationMultipleOptions(
                      field.name,
                      documentDefaultLang,
                      defaultLanguage
                    )
                  }}
                </h3>
                <p
                  v-if="
                    !['map', 'date', 'url', 'multi-select'].includes(
                      field.type.toLowerCase()
                    )
                  "
                  class="primary--text mt-1 text-and-area"
                  v-html="
                    findTranslationMultipleOptions(
                      field.value,
                      documentDefaultLang,
                      defaultLanguage
                    )
                  "
                ></p>

                <!-- Multi Select -->
                <div v-else-if="field.type.toLowerCase() === 'multi-select'">
                  <div class="mb-2">
                    <span>{{
                      findTranslationMultipleOptions(
                        field.value,
                        documentDefaultLang,
                        defaultLanguage
                      ).text
                    }}</span>
                  </div>

                  <v-checkbox
                    v-for="item in findTranslationMultipleOptions(
                      field.value,
                      documentDefaultLang,
                      defaultLanguage
                    ).items"
                    :key="item.label"
                    v-model="item.value"
                    class="multi-select-check"
                    dense
                    hide-details
                    value
                    :label="item.label"
                    disabled
                  ></v-checkbox>
                </div>

                <p
                  v-else-if="field.type.toLowerCase() === 'date'"
                  class="primary--text mt-1"
                >
                  {{
                    momentDate(
                      findTranslationMultipleOptions(
                        field.value,
                        documentDefaultLang,
                        defaultLanguage
                      )
                    )
                  }}
                </p>

                <base-U-R-L-Field
                  v-else-if="field.type.toLowerCase() === 'url'"
                  :value="
                    findTranslationMultipleOptions(
                      field.value,
                      documentDefaultLang,
                      defaultLanguage
                    )
                  "
                  :editMode="false"
                ></base-U-R-L-Field>

                <new-base-map
                  v-else
                  :location="
                    findTranslationMultipleOptions(
                      field.value,
                      documentDefaultLang,
                      defaultLanguage
                    )
                  "
                  :height="'350px'"
                  :zoom="14"
                  class="mt-1 mb-4"
                ></new-base-map>
              </div>

              <div
                v-else-if="field.type.toLowerCase() === 'linksto'"
                :key="
                  findTranslationMultipleOptions(
                    field.name,
                    documentDefaultLang,
                    defaultLanguage
                  )
                "
                class="pa-0 supply-chain-content"
              >
                <h3
                  v-if="
                    findTranslationMultipleOptions(
                      field.value,
                      documentDefaultLang,
                      defaultLanguage
                    ).filter(i => i.available).length > 0
                  "
                >
                  {{
                    findTranslationMultipleOptions(
                      field.name,
                      documentDefaultLang,
                      defaultLanguage
                    )
                  }}
                </h3>

                <v-list
                  v-if="
                    findTranslationMultipleOptions(
                      field.value,
                      documentDefaultLang,
                      defaultLanguage
                    ).filter(i => i.available).length > 0
                  "
                >
                  <template
                    v-for="(item, itemIndex) in findTranslationMultipleOptions(
                      field.value,
                      documentDefaultLang,
                      defaultLanguage
                    )"
                  >
                    <v-list-item
                      v-if="item.available"
                      :key="`${item.id}-i-${itemIndex}`"
                      class="pa-0 cursor-pointer"
                      :class="[item.type !== 'CUSTOM' ? 'cursor-pointer' : '']"
                      @click="redirectToLink(item)"
                    >
                      <v-avatar
                        :width="item.type !== 'PROFILE' ? '80px' : '30px'"
                        height="30px"
                        left
                        tile
                        class="mr-1"
                      >
                        <base-image
                          type="u"
                          image-type="t"
                          :file-name="item.logo"
                          :profile-id="getProfileId(item)"
                          :contain="false"
                          :imageAlt="
                            `${$t('linked')} ${item.type.toLowerCase()} ${$t(
                              'inShowcase'
                            )} ${document.name}`
                          "
                        ></base-image>
                      </v-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          ><h6 class="primary--text">
                            {{ item.name }}
                          </h6></v-list-item-title
                        >
                        <v-list-item-subtitle>
                          <v-chip color="brand" outlined label x-small>{{
                            item.type === 'DOCUMENT'
                              ? $t('showcase')
                              : sentenceCase(setI18nSyntax(item.type))
                          }}</v-chip></v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </div>

              <v-row
                v-else
                justify="center"
                align="center"
                class="ma-0"
                :key="
                  `${documentKey}${findTranslationMultipleOptions(
                    field.name,
                    documentDefaultLang,
                    defaultLanguage
                  )}-${i}`
                "
              >
                <div
                  v-if="field.type.toLowerCase() !== 'file'"
                  class="supply-chain-content"
                  :key="
                    `${documentKey}
                    ${findTranslationMultipleOptions(
                      field.name,
                      documentDefaultLang,
                      defaultLanguage
                    )}`
                  "
                >
                  <h3>
                    {{
                      findTranslationMultipleOptions(
                        field.name,
                        documentDefaultLang,
                        defaultLanguage
                      )
                    }}
                  </h3>
                  <p
                    class="primary--text mt-1"
                    v-html="
                      findTranslationMultipleOptions(
                        field.value,
                        documentDefaultLang,
                        defaultLanguage
                      )
                    "
                  ></p>
                </div>

                <base-multiple-images
                  v-if="
                    field.accepts &&
                      field.accepts[0].toLowerCase() === 'image' &&
                      field.value.names &&
                      field.value.names.length > 0 &&
                      field.value.names[0] !== ''
                  "
                  type="u"
                  image-type="o"
                  :profile-id="profileInfo.profile.profileId.replace('#', '')"
                  :editMode="false"
                  :file-names="field.value.names"
                  :aspectRatio="1.618"
                  :file-text="
                    field.text
                      ? findTranslationMultipleOptions(
                          field.text,
                          documentDefaultLang,
                          defaultLanguage
                        )
                      : ''
                  "
                  style="border-radius: 3px; width: 100%"
                  width="100%"
                  :key="documentKey"
                  class="mb-4"
                  :imageAlt="
                    `${$t('imagesForShowcase')} ${
                      document.name
                    } ${findTranslationMultipleOptions(
                      field.name,
                      documentDefaultLang,
                      defaultLanguage
                    )}`
                  "
                ></base-multiple-images>

                <base-video-player
                  v-else-if="
                    field.accepts &&
                      field.accepts[0].toLowerCase() === 'video' &&
                      field.value.names &&
                      field.value.names.length > 0 &&
                      field.value.names[0] !== ''
                  "
                  type="u"
                  video-type="o"
                  :profile-id="profileInfo.profile.profileId.replace('#', '')"
                  :file-name="field.value.names[0]"
                  width="100%"
                  :key="documentKey"
                  :videoKey="`video-key-${documentKey}`"
                  class="mb-4"
                ></base-video-player>

                <base-sound-player
                  v-else-if="
                    field.accepts &&
                      field.accepts[0].toLowerCase() === 'audio' &&
                      field.value.names &&
                      field.value.names.length > 0 &&
                      field.value.names[0] !== ''
                  "
                  type="u"
                  sound-type="o"
                  :profile-id="profileInfo.profile.profileId.replace('#', '')"
                  :file-name="field.value.names[0]"
                  :artist="profileInfo.profile.name"
                  width="100%"
                  :key="documentKey"
                  class="mb-4"
                ></base-sound-player>

                <base-download
                  v-else-if="
                    field.accepts &&
                      field.accepts[0].toLowerCase() === 'pdf' &&
                      field.value.names &&
                      field.value.names.length > 0 &&
                      field.value.names[0] !== ''
                  "
                  type="u"
                  download-type="o"
                  :profile-id="profileInfo.profile.profileId.replace('#', '')"
                  :file-name="field.value.names[0]"
                  :show="true"
                  width="100%"
                  :key="documentKey"
                  class="mb-4"
                ></base-download>

                <base-video-link
                  v-if="
                    field.accepts &&
                      field.accepts[0].toLowerCase() === 'video_link' &&
                      field.value.names &&
                      field.value.names.length > 0 &&
                      field.value.names[0] !== ''
                  "
                  height="315px"
                  :value="field.value.names[0]"
                  :key="documentKey"
                  class="mb-4"
                ></base-video-link>
              </v-row>
            </template>
          </div>
        </v-expand-transition>
      </div>
    </template>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { TemplateArrayHelpers } from '@/utilities/mixins/TemplateArrayHelpers';
import { MomentMixin } from '@/utilities/mixins/MomentMixin.js';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

import camelCase from 'lodash/camelCase';

const BaseImage = () =>
  import('@/components/base_components/BaseImage/BaseImage.vue');
const BaseMultipleImages = () =>
  import(
    '@/components/base_components/BaseMultipleImages/BaseMultipleImages.vue'
  );
// const BaseMap = () =>
//   import('@/components/base_components/BaseMap/BaseMap.vue');
const NewBaseMap = () =>
  import('@/components/base_components/NewBaseMap/NewBaseMap.vue');
const BaseVideoPlayer = () =>
  import('@/components/base_components/BaseVideoPlayer/BaseVideoPlayer.vue');
const BaseSoundPlayer = () =>
  import('@/components/base_components/BaseSoundPlayer/BaseSoundPlayer.vue');
const BaseDownload = () =>
  import('@/components/base_components/BaseDownload/BaseDownload.vue');
const BaseVideoLink = () =>
  import('@/components/base_components/BaseVideoLink/BaseVideoLink.vue');
const BaseURLField = () =>
  import('@/components/base_components/BaseURLField/BaseURLField.vue');

export default {
  name: 'BaseShowcaseTabs',
  components: {
    BaseImage,
    BaseVideoPlayer,
    BaseSoundPlayer,
    BaseDownload,
    // BaseMap,
    NewBaseMap,
    BaseVideoLink,
    BaseMultipleImages,
    BaseURLField
  },

  props: {
    title: {
      type: String,
      default: () => ''
    },

    document: {
      type: Object,
      default: () => {}
    },

    profileInfo: {
      type: Object,
      required: true
    },

    documentKey: {
      type: String,
      required: false,
      default: 'showcase-tabs-'
    }
  },

  data: () => ({
    active: 0
  }),

  mixins: [TemplateArrayHelpers, MomentMixin],

  mounted() {
    this.addBlankTarget();
  },

  computed: {
    ...mapState(['defaultLanguage']),
    documentDefaultLang() {
      return this.document?.defaultLanguage;
    },

    documentTabs() {
      if (this.document) {
        const onlyPopulatedSections = this.document.template.filter(step => {
          const emptySection = this.sectionIsEmpty(step.fields);
          return !emptySection;
        });

        const [basicInformation, ...other] = onlyPopulatedSections;
        return other.map(step => {
          return this.findTranslationMultipleOptions(
            step.name,
            this.documentDefaultLang,
            this.defaultLanguage
          );
        });
      }
      return [];
    },

    onlyPopulatedSections() {
      if (this.document) {
        const onlyPopulatedSections = this.document.template.filter(step => {
          const emptySection = this.sectionIsEmpty(step.fields);
          return !emptySection;
        });
        // eslint-disable-next-line no-unused-vars
        const [basicInformation, ...other] = onlyPopulatedSections;
        const fields = other?.[this.active]?.fields || [];
        return fields;
      } else {
        return [];
      }
    },

    icons: () => ({
      mdiChevronUp,
      mdiChevronDown
    })
  },

  methods: {
    onlyPopulatedFields(fields) {
      const filterFields = fields.filter(field => {
        if (field.type === 'FILE') return field?.value?.names?.length;
        else if (Array.isArray(field.value)) return field.value.length !== 0;
        else if (field.type === 'MULTI-SELECT') {
          return this.findTranslationMultipleOptions(
            field.value,
            this.documentDefaultLang,
            this.defaultLanguage
          )
            .items.map(item => item.value)
            .includes(true);
        }
        return (
          this.findTranslationMultipleOptions(
            field.value,
            this.documentDefaultLang,
            this.defaultLanguage
          ) !== '' &&
          this.findTranslationMultipleOptions(
            field.value,
            this.documentDefaultLang,
            this.defaultLanguage
          ) !== null
        );
      });
      return filterFields;
    },

    sectionIsEmpty(fields) {
      const hey = fields.every(field => {
        if (field.type !== 'FILE') {
          if (
            this.findTranslationMultipleOptions(
              field.value,
              this.documentDefaultLang,
              this.defaultLanguage
            )
          ) {
            return false;
          } else {
            return true;
          }
          //need to account for empty file arrays or empty value
        } else {
          if (field?.value?.names && field.value.names[0]) return false;
          return true;
        }
      });
      // return fields.every(field => {
      //   return (
      //     this.findTranslationMultipleOptions(field.value, this.defaultLanguage) === '' ||
      //     field.value.length === 0
      //   );
      // });
      return hey;
    },

    getProfileId(item) {
      if (item.type === 'PROFILE') return item.id;

      return item.profile.profileId;
    },

    setI18nSyntax(name) {
      if (name.includes('_')) {
        const nameWithoutUnderScore = name.replace('_', ' ');
        return this.$t(camelCase(nameWithoutUnderScore));
      } else if (name.includes(' ')) {
        return this.$t(camelCase(name));
      } else {
        return this.$t(camelCase(name));
      }
    },

    sentenceCase(toSentencefy) {
      return toSentencefy
        .split(/(?=[A-Z])/)
        .map(s => s[0].toUpperCase() + s.substring(1))
        .join(' ');
    },

    redirectToLink(item) {
      if (item.type === 'CUSTOM') return;

      if (item.type === 'PROFILE') {
        this.$router.push(`/profile/${item.id}/${this.defaultLanguage}`);
      } else {
        this.$router.push(`/showcase/${item.id}/${this.defaultLanguage}`);
      }
    },

    addBlankTarget() {
      const possibleAParents = document.getElementsByClassName('text-and-area');

      possibleAParents.forEach(parent => {
        const aChildNodes = parent.getElementsByTagName('a');
        if (aChildNodes.length > 0) {
          aChildNodes.forEach(node => {
            node.setAttribute('target', '_blank');

            const att = node.getAttribute('href');
            if (!att.includes('http'))
              node.setAttribute('href', `http://${att}`);
          });
        }
      });
    },

    hanldeActiveSection(index) {
      if (index === this.active) return (this.active = null);

      this.active = index;
    }
  }
};
</script>

<style scoped>
.clamp-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.clamp-profile-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.grid-container {
  display: grid;
  /*
    outer columns get min width 1.2rem and max width of 1fr
    inner columns get min width of auto and max width of 65ch
  */
  grid-template-columns: minmax(1.2rem, 1fr) minmax(auto, 65ch) minmax(
      1.2rem,
      1fr
    );

  /*
    20px space between each row of grid
  */
  grid-row-gap: 20px;
}

/* position text paragraphs into the second (middle) column */
.supply-chain-content {
  grid-column: 1/-1;
}

/* position images to take up all three columns */
.grid-image {
  grid-column: 1/-1;
  width: 100%;
  /* max-width: 100ch; */
  justify-self: left;
}

p {
  max-width: 80ch;
}

.text-and-area {
  color: red;
}

.xs-tab {
  padding: 8px;
  margin: 8px 0px;
  background-color: #f6f8fa;
  border-radius: 5px;
}

.xs-tab-active {
  padding: 8px;
  margin: 8px 0px;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px var(--v-brand-base);
}

.multi-select-check.v-input--selection-controls {
  margin-top: 0px;
}
</style>

<style>
.multi-select-check.v-input--is-disabled.v-input--is-dirty
  > .v-input__control
  > .v-input__slot
  > .v-input--selection-controls__input
  > .v-icon {
  color: var(--v-brand-base) !important;
}
</style>
